import { combineReducers } from 'redux';
import { reducer as base } from './base';
import { reducer as historicalRangeData } from './historicalRangeData';
import { reducer as liveData } from './liveData';
import { reducer as sharing } from './sharing';
import { reducer as dashboard } from './dashboard';
import { reducer as tempDashboard } from './tempDashboard';

export default combineReducers({
  base,
  historicalRangeData,
  liveData,
  sharing,
  dashboard,
  tempDashboard,
});
